// Production rates from ICPAK Binder Terms (May 2026).
export const piRatesData = {
    product: "pi",
    version: "1.0.0",
    limitBands: [
        { limitKes: 1000000, basicPremiumKes: 4710 },
        { limitKes: 1500000, basicPremiumKes: 6820 },
        { limitKes: 2000000, basicPremiumKes: 8076 },
        { limitKes: 3000000, basicPremiumKes: 10437 },
        { limitKes: 4000000, basicPremiumKes: 13701 },
        { limitKes: 5000000, basicPremiumKes: 17117 },
        { limitKes: 10000000, basicPremiumKes: 29171 },
        { limitKes: 20000000, basicPremiumKes: 66337 },
        { limitKes: 30000000, basicPremiumKes: 90445 },
        { limitKes: 40000000, basicPremiumKes: 120580 },
        { limitKes: 50000000, basicPremiumKes: 150715 },
    ],
    levies: { trainingLevyPct: 0.0025, policyHolderFundPct: 0.0025 },
    stampDutyKes: 40,
};
